'use client';

import { Box } from '@terra/ui-styled-system';
import { BodyDefault } from '@terra/ui-design-system';
import { useTranslations } from 'next-intl';
import { useEndpointsPreview } from '../../hooks/api/useEndpointsPreview';
import { ExpectedResponseObservationsSection } from './ExpectedResponseObservationsSection';

type ExecutionAuditLogTabProps = {
  applicationId: string;
  threadId: string | undefined;
  executionStatus: 'running' | 'completed' | 'error' | 'aborted';
  isAttackSkipped?: boolean;
  onNavigateToToolCall?: (toolCallId: string) => void;
};

export function ExecutionAuditLogTab({
  applicationId,
  threadId,
  executionStatus,
  isAttackSkipped = false,
  onNavigateToToolCall,
}: ExecutionAuditLogTabProps) {
  const t = useTranslations('expectedResponseObservations');
  const { endpoints } = useEndpointsPreview({ applicationId });
  // Failed and aborted runs also publish NEO_RUN_FINISHED and record
  // observations; only a 'running' run (or a skipped attack) has none yet.
  const shouldFetchObservations = !!applicationId && !!threadId;

  if (executionStatus === 'running' || isAttackSkipped) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        w="full"
        py={12}
      >
        <BodyDefault color="fg.muted" textAlign="center" maxW="md">
          {isAttackSkipped ? t('skippedNotice') : t('runningNotice')}
        </BodyDefault>
      </Box>
    );
  }

  return (
    <ExpectedResponseObservationsSection
      applicationId={applicationId}
      threadId={threadId}
      endpoints={endpoints}
      enabled={shouldFetchObservations}
      onNavigateToToolCall={onNavigateToToolCall}
    />
  );
}
